import { TooltipTypography } from '@precis-digital/kurama/Tooltip';
import { styled } from '@precis-digital/kurama/utils';
import { type ReactElement } from 'react';
const SKILL_DESCRIPTION_MAX_LINES = 4;

/** Skill description in a tooltip, clamped so long Flow descriptions end with an ellipsis. */
export const SkillTooltipDescription = styled(TooltipTypography)({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: SKILL_DESCRIPTION_MAX_LINES,
  WebkitBoxOrient: 'vertical',
  overflowWrap: 'anywhere'
});

/** Tooltip body for a skill description; `undefined` when empty so no tooltip is shown. */
export const getSkillDescriptionTooltipBody = (description: string): ReactElement | undefined => description.trim() !== '' ? <SkillTooltipDescription variant="body2">{description}</SkillTooltipDescription> : undefined;